import { render, staticRenderFns } from "./TournamentGroup.vue?vue&type=template&id=857e24fc&scoped=true"
import script from "./TournamentGroup.vue?vue&type=script&lang=js"
export * from "./TournamentGroup.vue?vue&type=script&lang=js"
import style0 from "./TournamentGroup.vue?vue&type=style&index=0&id=857e24fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857e24fc",
  null
  
)

export default component.exports